export default __webpack_public_path__ + "static/media/Schedule-Meeting.b1af5be8.svg";